import React from 'react';
import AboutUsEn from '../components/AboutUsEn';
import GroupImageEn from '../components/GroupImageEn';
import AdditionalInfoEn from '../components/AdditionalInfoEn';
import DetailedHistoryEn from '../components/DetailedHistoryEn';

function AboutUsPageEn() {
  return (
    <div className="page">
      <AboutUsEn />
      <AdditionalInfoEn />
      <GroupImageEn />
      <DetailedHistoryEn />
    </div>
  );
}

export default AboutUsPageEn;
